(function () {
  function jappsTickerInit() {
    document.querySelectorAll('.js-japps-usp-ticker').forEach((ticker) => {
      ticker.classList.remove('japps-opacity-0');

      const track = ticker.querySelector('.js-japps-usp-track');
      const template = ticker.querySelector('.japps-usp-template');
      if (!track || !template) return;

      track.querySelectorAll('.js-japps-usp-content-clone').forEach((el) => el.remove());

      if (track._jappsAnim) {
        track._jappsAnim.cancel();
        track._jappsAnim = null;
      }

      requestAnimationFrame(() => {
        const width = template.getBoundingClientRect().width;

        if (width === 0) {
          setTimeout(jappsTickerInit, 60);
          return;
        }

        const speed = parseFloat(ticker.dataset.speed || 40);
        const clones = Math.ceil((window.innerWidth * 2) / width);

        for (let i = 0; i < clones; i++) {
          const clone = template.cloneNode(true);
          clone.classList.remove('japps-usp-template');
          clone.classList.add('js-japps-usp-content-clone');
          track.appendChild(clone);
        }

        const scrollDistance = track.scrollWidth / 2;
        const duration = Math.max(speed, (speed / 1440) * window.innerWidth);

        const anim = track.animate(
          [
            { transform: 'translateX(0)' },
            { transform: `translateX(-${scrollDistance}px)` },
          ],
          {
            duration: duration * 1000,
            iterations: Infinity,
            easing: 'linear',
          }
        );

        track._jappsAnim = anim;

        if (window.matchMedia('(min-width: 1280px)').matches) {
          if (!ticker._jappsHoverBound) {
            ticker.addEventListener('mouseenter', () => track._jappsAnim && track._jappsAnim.pause());
            ticker.addEventListener('mouseleave', () => track._jappsAnim && track._jappsAnim.play());
            ticker._jappsHoverBound = true;
          }
        }
      });
    });
  } 

  jappsTickerInit();

  // Dawn cart.js pubsub hook
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
      requestAnimationFrame(() => requestAnimationFrame(jappsTickerInit));
    });
  }

  document.addEventListener('click', (e) => {
    if (e.target && e.target.closest && e.target.closest('#cart-icon-bubble')) {
      setTimeout(jappsTickerInit, 50);
    }
  });
})();